var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3258 1H2.67422C1.81987 1 1.35896 2.00212 1.91496 2.65079L6.25926 7.71913C6.41461 7.90038 6.5 8.13121 6.5 8.36992V13.382C6.5 13.7607 6.714 14.107 7.05279 14.2764L9.05279 15.2764C9.71769 15.6088 10.5 15.1253 10.5 14.382V8.36992C10.5 8.13121 10.5854 7.90038 10.7407 7.71913L15.085 2.65079C15.641 2.00212 15.1801 1 14.3258 1Z",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a655ff8fcad1db57075a3e379fc86639.svg";
export { ForwardRef as ReactComponent };